
import { createApp } from 'vue'

import App from '@/App.vue';
import { createGlobalRouter } from '@/router.js';
import Toaster from "@/utils/plugins/toaster";
import httpService from '@/services/httpService.js';
import themeService from '@/services/themeService.js';
import eventBus from '@/utils/eventBus.js';
// import sessionService from '@/services/sessionService.js';
import Modals from '@/utils/plugins/modals.js'

import Loader from '@/components/_Loader.vue';
import BaseIcon from '@/components/BaseIcon.vue';
import BaseAlert from '@/components/BaseAlert.vue';
import ErrorList from '@/components/ErrorList.vue';
import FormField from '@/components/FormField.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';

// import {getResponseMessage} from '@/utils/index.js';

import tooltipDirective from '@/directives/tooltip.js';

const app = createApp(App);
const router = createGlobalRouter(app);

app.component('Loader', Loader);
app.component('BaseIcon', BaseIcon);
app.component('BaseAlert', BaseAlert);
app.component('ErrorList', ErrorList);
app.component('FormField', FormField);
app.component('Breadcrumbs', Breadcrumbs);

app.directive('tooltip', tooltipDirective);

app.provide('$http', httpService);
app.provide('$eventHub', eventBus);

app.use(Modals);
app.use(Toaster, {position: "top", maxToasts: 7});

async function initApp(app){
    // let userData = await sessionService.initSession(app);
    // app.provide('$user', userData);
    app.use(router);
    app.mount('#app');
}

app.config.devtools = process.env.NODE_ENV !== 'production';
// app.config.globalProperties.$resMsg = getResponseMessage;
app.config.globalProperties.$isDev = process.env.NODE_ENV === 'development';
app.config.globalProperties.$platform = window.platform ? window.platform : null;
app.config.globalProperties.$authUser = window.authUser;
app.config.globalProperties.$http = httpService;
app.config.globalProperties.$theme = themeService;
app.config.globalProperties.$eventHub = eventBus;
app.config.globalProperties.$initGlobalErrors = globalError;
app.config.globalProperties.$initApp = (app) => initApp(app);

async function globalError(error, unmount){
    let component;
    if(unmount) app.unmount();

    if(error.code === 'EMAIL_NOT_VERIFIED'){
        component = await import("@/views/AuthNotice.vue");
    }

    if(!component) return;
    
    const noticeApp = createApp(component.default, { data: error });

    noticeApp.use(Toaster, { position: "top" });
    noticeApp.mount("#app");
}

initApp(app);